import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import popupimage from "../../assets/popup.svg";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { StoreLocationAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { GetCity, GetState } from "../../Utils/Api/SignUP";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import Loader from "../Loader/Loader";
import AutoCompleteInput from "../AutoCompleteInput/AutoCompleteInput";
import { RotatingLines } from "react-loader-spinner";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";

const EditLocationModal = ({ keyfuc, ...props }) => {
  const [locationData, setLocationData] = useState({
    sl_address: props.store_address,
    sl_state: props.state_id,
    sl_city: props.city_name,
    sl_zipcode: props.store_zipcode,
    storelocation_id: props.storelocation_id,
  }); //for creation

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [cityValue, setCityValue] = useState("");
  const [editFlag, setEditFlag] = useState(false);

  // console.log(locationData);
  // console.log(props);

  const navigate = useNavigate();

  const CloseHandler = () => {
    setCityValue("");
    props.onHide();
    setError("");
  };

  const getState = async () => {
    const data = {
      country_id: 233,
    };
    const stateData = await GetState(data, () => {
      navigate("/");
    });
    setStateList(stateData.data);
  };

  const CityInputHandler = (e, flag) => {
    let val = e.target.value;
    setCityValue(val);
    // props.editInfo.city_name
    setEditFlag(flag);
  };

  const getCity = async (state_id) => {
    const dat = {
      state_id: state_id,
    };
    const cityData = await GetCity(dat, () => {
      navigate("/");
    });
    setCityList(cityData.data);
  };

  const handleAddLocation = async () => {
    // console.log(locationData);
    const d = {
      bu_id: Bu_id,
      sl_address: locationData.sl_address,
      sl_state: locationData.sl_state,
      sl_city: editFlag === true ? cityValue : props.city_name,
      sl_zipcode: locationData.sl_zipcode,
      storelocation_id: props.storelocation_id,
      api_method: "post",
    };

    const regex = /^[a-zA-Z0-9]*$/;

    if (
      d.sl_address === "" ||
      (editFlag === true && cityValue === "") ||
      d.sl_state === "" ||
      d.sl_zipcode === "" ||
      !d.sl_address ||
      (editFlag === true && !cityValue) ||
      !d.sl_state ||
      !d.sl_zipcode
    ) {
      setError("Please fill up the form");
    } else if (regex.test(d.sl_zipcode) === false) {
      setError("Please enter a valid zipcode!");
    } else {
      setLoading(true);
      const addLocation = await StoreLocationAPI(d);
      if (addLocation === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setError("");
        setLoading(false);
      } else {
        if (addLocation.success === true) {
          keyfuc(!props.key);
          toast.success("Store Location Updated", {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setError("");
          setLoading(false);
          props.show(false);
        }else if (addLocation.status === 429) {
          setLoading(true);
          toast.error(addLocation.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          toast.error(addLocation.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setError("");
          setLoading(false);
        }
      }
    }
  };

  const Bu_id = userId();

  const handleChange = (e) => {
    if (e.target.name === "sl_state") {
      getCity(e.target.value);
    }
    setLocationData({
      ...locationData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSend = (e) => {
    e.preventDefault();
    handleAddLocation();
  };

  useEffect(() => {
    getState();
  }, []);

  useEffect(() => {
    setLocationData({
      sl_address: props.store_address,
      sl_state: props.state_id,
      sl_city: props.city_id,
      sl_zipcode: props.store_zipcode,
      storelocation_id: props.storelocation_id,
    });
  }, [props.edit]);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal"
      >
        <Modal.Header onClick={CloseHandler} closeButton></Modal.Header>
        <Modal.Body className="mb-5 edit-loc-modal">
          <p className="text-center mb-3">
            {" "}
            <Image loading="lazy" src={popupimage} />
          </p>
          <p className="page-maintitle text-center">Edit Location</p>
          <Row>
            <Col md="12">
              <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4">
                <Row>
                  <Col md="12" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Address Line <span className="star-required">* </span>
                      </Form.Label>

                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          placeholder="Address Line"
                          className="custom-formcontrol"
                          maxLength={200}
                          name="sl_address"
                          onChange={handleChange}
                          // value={
                          //   props.edit === true
                          //     ? locationData.sl_address
                          //     : editInfo.store_address
                          // }
                          defaultValue={props.store_address}
                          autoComplete="off"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        State / Province{" "}
                        <span className="star-required">* </span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Group className="mb-0" controlId="formBasicEmail">
                          <Form.Select
                            aria-label="Default select example"
                            className="custom-select edit-table-select"
                            name="sl_state"
                            onChange={handleChange}
                          >
                            <option>{props.state_name}</option>
                            {stateList?.length > 0 ? (
                              stateList.map((data) => {
                                return (
                                  <option
                                    value={data.state_id}
                                    key={data.state_id}
                                  >
                                    {data.state_name}
                                  </option>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </Form.Select>
                        </Form.Group>
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  <AutoCompleteInput
                    CityList={cityList}
                    EditFlag={editFlag}
                    EditCity={cityValue}
                    ApiCity={props.city_name}
                    onCityFuc={CityInputHandler}
                    ErrDisplay={""}
                    NameFlag={"sl_city"}
                    Md={"4"}
                  />

                  {/* <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        City <span className="star-required">* </span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Group className="mb-0" controlId="formBasicEmail">
                          <Form.Select
                            aria-label="Default select example"
                            className="custom-select edit-table-select"
                            name="sl_city"
                            onChange={handleChange}
                            //   value={props.editInfo.city_name}
                          >
                            <option>{props.city_name}</option>
                            {cityList && cityList?.length > 0 ? (
                              cityList.map((data) => {
                                console.log("city", cityList);
                                return (
                                  <option
                                    value={data.mms_city_id}
                                    key={data.mms_city_id}
                                  >
                                    {data.city_name}
                                  </option>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </Form.Select>
                        </Form.Group>
                      </InputGroup>
                    </Form.Group>
                  </Col> */}

                  <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Zipcode <span className="star-required">* </span>
                      </Form.Label>

                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          placeholder="zipcode"
                          className="custom-formcontrol"
                          maxLength={10}
                          name="sl_zipcode"
                          defaultValue={props.store_zipcode}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <center>
                    <ErrorLabel ErrorDisplay={error} />
                  </center>
                  <div className="text-center small-btns d-flex table-button-width">
                    <Link onClick={CloseHandler}>
                      <p className="view">Cancel</p>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={handleSend}
                    >
                      {loading === true ? (
                        <RotatingLines
                          strokeColor="white"
                          width={20}
                          visible={true}
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditLocationModal;
